module.exports = __webpack_public_path__ + "static/media/Calendar-small.bbf852cf.svg";